//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import therapeut from '~/graphql/queries/therapeut.gql';

export default {
  auth: false,
  apollo: {
    therapeut: {
      query: therapeut,
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
      skip() {
        return !this.$route.params.slug;
      },
    },
  },
  data: () => ({
    therapeut: null,
  }),
  computed: {
    naam() {
      let title = '';
      switch (this.therapeut.geslacht) {
        case 'Man':
          title = 'Dhr. ';
          break;
        case 'Vrouw':
          title = 'Mvr. ';
          break;
      }
      return title +
        (this.therapeut.voorletters ?? this.therapeut.voornaam[0] + '.') +
        (this.therapeut.tussenvoegsel ? ` ${this.therapeut.tussenvoegsel} ` : ' ') +
        (this.therapeut.achternaam);
    },
  },
  methods: {
    parseUrl(url) {
      if (url.startsWith('http')) {
        return url;
      }

      return 'https://' + url;
    },
  },
  head() {
    return {
      title: this.therapeut ? this.therapeut?.title : null,
    };
  },
};
